import { Container } from "@mui/material";
import { AssignmentsRegistrySectionContent } from "../assignments-registry-section-content";
import { AssignmentsRegistrySectionTop } from "../assignments-registry-section-top";
import { useEffect } from "react";
import {
  assignmentsLoadAssignments,
  assignmentsLoadManagers,
} from "redux/slices/assignments.slice";
import { useURLParamsAssignments, useURLParamsSpreadsheets } from "hooks";
import { useDispatch } from "react-redux";
import { useForUserType } from "hooks/useForUserType";

const limit = 10;

export const AssignmentsRegistrySection = () => {
  const { userType } = useForUserType();
  const { page } = useURLParamsAssignments();
  const dispatch = useDispatch();

  const { assignmentType, companyName, applicationNo, assigneeId, applicationYear } =
    useURLParamsSpreadsheets();

  useEffect(() => {
    dispatch(
      assignmentsLoadAssignments({
        limit: limit,
        offset: (page.get() - 1) * limit,
        userType: userType,
        application_no: Number(applicationNo.get()),
        assignment_type: assignmentType.get(),
        company_name: companyName.get(),
        assignee_id: assigneeId.get(),
        application_year: applicationYear.get(),
      })
    );
    dispatch(assignmentsLoadManagers());
  }, [userType]);

  return (
    <Container
      sx={{
        mt: "48px",
      }}
    >
      <AssignmentsRegistrySectionTop />
      <AssignmentsRegistrySectionContent />
    </Container>
  );
};
